import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem 5rem;
  margin-bottom: 2rem;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  margin: 3.6rem 5.3rem;
`;

export const SecondPageHeader = styled.header`
  width: 100%;
  height: 12rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 3.8rem 5.6rem;
  background: #242424;

  @media (max-width: 1024px) {
    padding: 2rem 4rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

export const SecondaryHeaderLine = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 1024px) {
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 425px) {
    justify-content: center;
    flex-wrap: nowrap;
  }
`;

export const SecondaryHeaderBackButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;

  font-size: 2.5rem;
  color: #ffdf22;

  @media (max-width: 1024px) {
    width: 48%;
  }

  @media (max-width: 425px) {
    width: auto;
  }

  p {
    margin-left: 0.5rem;
    font-weight: bold;
    letter-spacing: 1.25px;
    text-transform: uppercase;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 425px) {
      margin-left: 0;
    }

    @media (max-width: 425px) {
      display: none;
    }
  }
`;

export const SecondaryHeaderContinueButton = styled.button`
  width: 31.7rem;
  height: 4.4rem;
  background: #ffdf22;
  border-radius: 2.5rem;

  font-size: 1.8rem;
  font-weight: bold;

  @media (max-width: 1024px) {
    width: 48%;
  }

  @media (max-width: 425px) {
    width: 31.7rem;
  }

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const SecondaryHeaderInfo = styled.div`
  display: flex;

  @media (max-width: 425px) {
    padding-top: 2rem;
    align-items: center;
    justify-content: center;
  }

  div {
    color: #fff;
    font-size: 1.8rem;
    display: flex;

    margin-right: 3rem;
    p {
      margin-left: 0.4rem;
    }
  }
`;

type InfoProps = {
  hide?: boolean;
};

export const InfoButton = styled.button<InfoProps>`
  background: transparent;
  font-size: 0;

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4.4rem;

  max-width: 68.4rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-gap: 0rem;
    max-width: 32rem;
  }
`;

export const InputSet = styled.fieldset`
  border: none;
  margin-bottom: 2.5rem;

  div {
    border-radius: 2rem;
  }
`;

export const InputLabel = styled.label`
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;

  padding: 0.5rem 1.7rem;
`;

export const FormWarning = styled.p`
  color: red;
  font-size: 16px;
  margin-bottom: 30px;
`;
